
import { Mail, Phone, ArrowUp } from 'lucide-react';
import { useState, useEffect } from 'react';

const Footer = () => {
  const [isVisible, setIsVisible] = useState(false);
  
  // Show button when page is scrolled down
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  
  return (
    <>
      {/* Scroll to top button */}
      {isVisible && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-20 right-6 p-3 rounded-full bg-gradient-to-r from-primary to-secondary text-white shadow-lg transition-transform hover:scale-110 animate-bounce z-40"
          aria-label="Retour en haut"
        >
          <ArrowUp size={20} />
        </button>
      )}
      
      <footer className="bg-gradient-to-r from-secondary via-primary to-secondary text-white py-6 mt-auto relative overflow-hidden">
        {/* Animated background shapes */}
        <div className="absolute inset-0 overflow-hidden opacity-10">
          <div className="absolute top-10 left-10 w-20 h-20 rounded-full bg-white animate-pulse opacity-30"></div>
          <div className="absolute bottom-10 right-20 w-32 h-32 rounded-full bg-white animate-pulse opacity-20" style={{ animationDelay: '1s' }}></div>
          <div className="absolute top-10 right-40 w-16 h-16 rounded-full bg-white animate-pulse opacity-25" style={{ animationDelay: '1.5s' }}></div>
          <div className="absolute bottom-20 left-20 w-24 h-24 rounded-full bg-white animate-pulse opacity-15" style={{ animationDelay: '2s' }}></div>
        </div>
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="mb-4 md:mb-0 flex items-center group transition-transform duration-300 hover:scale-105">
              <img src="/lovable-uploads/c5e9bf5c-1418-4e99-b5e6-e0a55f0aede9.png" alt="Mucodec Logo" className="h-10 w-auto mr-3" />
              <div>
                <h2 className="text-lg font-semibold">Mucodec Alerte Licence </h2>
                <p className="text-sm opacity-80"> DIDISI Digital et Projet</p>
              </div>
            </div>
            
            <div className="flex flex-col md:flex-row gap-4 md:gap-8">
              <div className="flex items-center transition-all duration-300 hover:translate-x-2">
                <Phone className="h-4 w-4 mr-2" />
                <span className="text-sm">(+242) 06 987 90 00</span>
              </div>
              <div className="flex items-center transition-all duration-300 hover:translate-x-2">
                <Mail className="h-4 w-4 mr-2" />
                <span className="text-sm">Contact@mucodec.com</span>
              </div>
            </div>
            
            <div className="mt-4 md:mt-0">
              <a 
                href="#" 
                className="text-sm relative inline-block after:content-[''] after:absolute after:w-full after:scale-x-0 after:h-0.5 after:bottom-0 after:left-0 after:bg-white after:origin-bottom-right after:transition-transform after:duration-300 hover:after:scale-x-100 hover:after:origin-bottom-left"
              >
                Contact L'admin
              </a>
            </div>
          </div>
          
          <div className="mt-6 text-center text-xs opacity-70">
            © {new Date().getFullYear()}  DIDISI Digital et Projet
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
